import React from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { parseISO, format } from 'date-fns';
import { Line } from 'react-chartjs-2';

import { placeholderChartConfig } from './placeholderConfig';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  annotationPlugin,
);

// получаем случайный цвет для линии на графике в диапазоне синего и зелёного
const getRandomColor = () => {
  const r = 0;
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);
  return `rgb(${r}, ${g}, ${b})`;
};

// делаем из данных api структуру для для графика
const transformToChartData = (data) => {
  // это нужно для отрисовки горизонтальной линии на графике
  const annotations = {};

  const labels = data[0].stats.map((stat) => {
    const date = parseISO(stat[0]);
    return format(date, 'yyyy-MM-dd HH:mm');
  });

  const datasets = data.map((item) => {
    const currentColor = getRandomColor();

    if (item.threshold) {
      annotations[item.threshold] = {
        type: 'line',
        yMin: parseInt(item?.threshold, 10),
        yMax: parseInt(item?.threshold, 10),
        borderColor: currentColor,
        borderWidth: 1,
      };
    }

    const values = item.stats.map((stat) => stat[1]);

    const pointBackgroundColor = values.map((value) => (value > parseInt(item?.threshold, 10) ? 'rgba(255, 62, 51, 0.5)' : 'rgba(34, 195, 75, 0.5)'));

    return {
      label: item.streamName,
      data: values,
      fill: false,
      borderColor: currentColor,
      pointBackgroundColor,
      thickness: '1px',
      borderWidth: 1,
      pointBorderColor: 'transparent',
      pointRadius: 4,
      pointHoverRadius: 6,
    };
  });

  // это настройки блока легенды
  const options = {
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
          pointStyle: 'rect',
          color: 'black',
          boxWidth: 16,
        },
        position: 'bottom',
        align: 'start',
        reverse: false,
      },
      annotation: { annotations },
    },
  };

  return {
    labels,
    datasets,
    options,
  };
};

function Chart({ chartData }) {
  // если нет данных - рисуется путой график по данным из плейсхолдера
  const config = chartData
    ? transformToChartData(chartData)
    : placeholderChartConfig;

  return (
    <Line
      data={{
        labels: config.labels,
        datasets: config.datasets,
      }}
      options={config.options}
    />
  );
}

const memoizedChart = React.memo(Chart);

export { memoizedChart as Chart };
